export enum ReviewPageSections {
  SEAT_MAPS = 'seat_maps'
}
